'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withQueries = function withQueries(config) {
  return function (Decorated) {
    var WithQueries = function (_React$Component) {
      _inherits(WithQueries, _React$Component);

      function WithQueries() {
        _classCallCheck(this, WithQueries);

        return _possibleConstructorReturn(this, (WithQueries.__proto__ || Object.getPrototypeOf(WithQueries)).apply(this, arguments));
      }

      _createClass(WithQueries, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          console.log('componentDidMount');
          this.props.init(config.queries.map(function (q) {
            return q.init();
          }));
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var _props = this.props,
              requests = _props.requests,
              init = _props.init,
              update = _props.update,
              rest = _objectWithoutProperties(_props, ['requests', 'init', 'update']);

          var queries = config.queries.reduce(function (acc, cur) {
            return _extends({}, acc, _defineProperty({}, cur.name, cur.make(_this2.props)));
          }, {});

          var actions = config.actions.reduce(function (acc, cur) {
            return _extends({}, acc, _defineProperty({}, cur.name, cur.handler));
          }, {});

          return _react2.default.createElement(Decorated, _extends({}, rest, { queries: queries, actions: actions }));
        }
      }]);

      return WithQueries;
    }(_react2.default.Component);

    WithQueries.displayName = 'withQueries(' + Decorated.displayName + ')';

    WithQueries.__withQueries = function () {
      return config;
    };

    var mapState = function mapState(_ref) {
      var queries = _ref.queries,
          actions = _ref.actions,
          requests = _ref.requests;
      return { queries: queries, actions: actions, requests: requests };
    };
    var mapDispatch = { init: _actions.init, update: _actions.update };

    return (0, _reactRedux.connect)(mapState, mapDispatch)(WithQueries);
  };
};

exports.default = withQueries;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/withQueries.js
// module id = 264
// module chunks = 0